import {observer} from 'mobx-react';
import {Modal} from 'shared/components/modals';
import CustomHours from './CustomHours';
import BlockedDateDetails from './BlockedDateDetails';

const EventDetailsFactory = observer(({uiState}) => {
  const {selectedEvent} = uiState;

  switch (selectedEvent.extendedProps.type) {
    case 'time_off_request':
      return <CustomHours event={selectedEvent} onCloseModal={() => uiState.closeEventDetailsModal()}/>;
    case 'blocked_date':
      return <BlockedDateDetails event={selectedEvent}/>;
    default:
      throw new Error(`Type ${selectedEvent.extendedProps.type} is not supported.`);
  }
});

const EventDetailsModal = observer(({uiState, modalOpen}) => {
  const {selectedEvent} = uiState;

  return (
    <Modal
      title={selectedEvent.title}
      size='sm'
      isOpen={modalOpen}
      onHide={() => uiState.closeEventDetailsModal()}
    >
      <EventDetailsFactory uiState={uiState}/>
    </Modal>
  );
});

export default EventDetailsModal;
